/* eslint-disable */

const refHeaderWidth = 1100;


jQuery(function ($) {
  const links = $('.Header-menu #menu-menu-principal > li > a').toArray();

  if (window.location.pathname !== '/') {
    links.forEach(link => {
      if (link.href.includes(window.location.pathname)) {
        link.classList.add('active');
      }
    });
  }

  $(window).on('resize', function () {
    if (window.innerWidth > refHeaderWidth) {
      // $('.Header-hamburger').removeClass('active');
      $('.Header-menu').removeClass('open');
    }
  });

  $('.Header-search #search').on('keyup', function () {
    const search = $(this).val();

    if (search !== '') {
      $(this).parent().children('.btnClear').show();
    } else {
      $(this).parent().children('.btnClear').hide();
    }
  });

  $('#search-button').on('click', function () {
    $('.Header-search').css('display', 'flex');

    document.getElementById("search").focus();

    const search = $('#search').val();
    $('#search').val('');
    $('#search').val(search)

    if (search !== '') {
      $('.btnClear').show();
    } else {
      $('.btnClear').hide();
    }
  });

  $('.Header-search #close').on('click', function () {
    $('.Header-search').hide();
  });

  $('.btnClear').on('click', function () {
    $('.Header-search #search').val('');
    $(this).hide();
    document.getElementById("search").focus();
  });
});
